import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVault: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"vault, safe"} maskId="square-filled-radius-0-stroke-1-IconVault"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V18.875H6V21H7V18.875H17V21H18V18.875H21V3H3ZM16.5 11C16.5 13.4853 14.4853 15.5 12 15.5C9.68372 15.5 7.77619 13.75 7.52746 11.5H12V10.5H7.52746C7.77619 8.25002 9.68372 6.5 12 6.5C14.4853 6.5 16.5 8.51472 16.5 11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVault;
